import { type ReactNode } from 'react';
import './FieldRow.scss';

const FieldRow = ({ children }: { children: ReactNode }) => (
    <div className="front-royal-form-field-row">{children}</div>
);

export default FieldRow;
